import { isEmmaApp } from '../helpers/common';
import { useEmmaJS } from './useEmmaJS';
import { useCallback } from 'react';

export type OpenWebViewOptions = {
  topBarTitle?: string;
  isHideTopbarBackButton?: boolean;
  isHideTopbarCloseButton?: boolean;
  isHideBottomTabs?: boolean;
};

export const useOpenLink = (
  url: string,
  openWebViewOptions: OpenWebViewOptions,
) => {
  const emmaJs = useEmmaJS();
  const {
    topBarTitle = '',
    isHideTopbarBackButton = false,
    isHideTopbarCloseButton = true,
    isHideBottomTabs = false,
  } = openWebViewOptions;

  return useCallback(() => {
    if (isEmmaApp) {
      const deeplink = `emma-webview?isHideTopbarBackButton=${isHideTopbarBackButton}&isHideTopbarCloseButton=${isHideTopbarCloseButton}&isHideBottomTabs=${isHideBottomTabs}&initialTopBarTitle=${topBarTitle}&url=${encodeURIComponent(
        url,
      )}`;

      emmaJs.instance.goTo(deeplink);
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.open(url);
    }
  }, [
    emmaJs,
    isEmmaApp,
    isHideTopbarBackButton,
    isHideTopbarCloseButton,
    isHideBottomTabs,
    topBarTitle,
    url,
  ]);
};
